import React, { useState, useEffect } from 'react';
import { backend_url } from '../../App';

const FEATURE_ICONS = [
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="1" y="3" width="15" height="13" rx="2"/>
    <path d="M16 8h4l3 5v3h-7V8z"/>
    <circle cx="5.5" cy="18.5" r="2.5"/>
    <circle cx="18.5" cy="18.5" r="2.5"/>
  </svg>,
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 4 23 10 17 10"/>
    <polyline points="1 20 1 14 7 14"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </svg>,
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.11h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 7.3 7.29l.95-.96a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>,
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>,
];

const DEFAULT_FEATURES = [
  { title: 'Free Shipping',   desc: 'Orders above Rs. 2,000',  accent: '#00d4ff' },
  { title: 'Easy Returns',    desc: '30-day hassle free',       accent: '#7c3aed' },
  { title: '24/7 Support',    desc: 'Always here to help',      accent: '#f59e0b' },
  { title: 'Secure Payment',  desc: '100% safe & encrypted',    accent: '#22c55e' },
];

const FeatureBar = () => {
  const [features, setFeatures] = useState(DEFAULT_FEATURES);

  useEffect(() => {
    fetch(`${backend_url}/homecontent`)
      .then(r => r.json())
      .then(data => {
        if (data.featureBar?.length) {
          setFeatures(data.featureBar.map((f, i) => ({ ...DEFAULT_FEATURES[i], ...f })));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="px-[5%] py-7 bg-[#060c18]" style={{ borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
      <div className="max-w-[1400px] mx-auto grid grid-cols-4 gap-4 max-[900px]:grid-cols-2 max-[480px]:grid-cols-1">
        {features.map((f, i) => (
          <div
            key={i}
            className="group relative flex items-center gap-4 px-5 py-4 rounded-2xl overflow-hidden cursor-default transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.4)]"
            style={{ background: `linear-gradient(135deg, ${f.accent}0d 0%, rgba(255,255,255,0.02) 100%)`, border: `1px solid ${f.accent}25` }}
          >
            {/* Glow on hover */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-2xl" style={{ background: `radial-gradient(circle at 20% 50%, ${f.accent}15 0%, transparent 60%)` }} />

            {/* Icon */}
            <div
              className="relative flex-shrink-0 w-[50px] h-[50px] rounded-[14px] flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style={{ background: `${f.accent}18`, color: f.accent, boxShadow: `0 4px 20px ${f.accent}20` }}
            >
              {FEATURE_ICONS[i]}
              {/* Icon glow on hover */}
              <div className="absolute inset-0 rounded-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ boxShadow: `0 0 20px ${f.accent}50`, background: `${f.accent}10` }} />
            </div>

            {/* Text */}
            <div className="relative">
              <p className="text-white font-bold text-[14px] leading-none mb-1.5">{f.title}</p>
              <p className="text-[#6b7a8d] text-[12px] leading-tight group-hover:text-[#8896a6] transition-colors">{f.desc}</p>
            </div>

            {/* Right accent line */}
            <div className="absolute right-0 top-[15%] bottom-[15%] w-[2px] rounded-l-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: `linear-gradient(180deg, transparent, ${f.accent}, transparent)` }} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureBar;
